import { render, staticRenderFns } from "./ProductServiceMicrositeTab.vue?vue&type=template&id=48a6379d&scoped=true"
import script from "./ProductServiceMicrositeTab.vue?vue&type=script&lang=js"
export * from "./ProductServiceMicrositeTab.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceMicrositeTab.vue?vue&type=style&index=0&id=48a6379d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6379d",
  null
  
)

export default component.exports